import {Paymodes} from '../../type-guards';

export interface GoTribeBenefit {
  id?: string;
  value: string;
  code?: string;
  imageURL?: string;
  category?: string;
  segmentIdentifier?: string;
  leafCategory?: string;
  iconUrl?: string;
  iconUrlV2?: string;
  text: string;
  iUrl: string;
  categoryId?: string;
  segmentId?: string;
  leafCategoryId?: string;
}

export interface GoTribeInfo {
  tierName?: string;
  tierNumber?: string;
  goTribeIconUrl?: string;
  goTribeIconUrlV2: string;
  benefitsTitle?: string;
  lineBgColour?: string[];
  title?: string;
  benefits: GoTribeBenefit[];
}

/* Room Selection */

export interface BenefitDetail {
  code: string;
  text: string;
  subText: string;
  segmentIdentifier: string;
  iconUrl: string;
  category: string;
  onOffer: boolean;
  bookable: boolean;
  packageBenefit: boolean;
  iUrl: string;
  iconType?: string;
}

export interface GoTribeInclusionShape {
  text: string;
  onOffer: boolean;
  bookable: boolean;
  goTribeIconUrl: string;
  goTribeIconUrlV2: string;
  benefitImageUrl: string;
  ctaGoTribeIconUrl: string;
  ctaGoTribeIconUrlV2: string;
  roomOrMealUpgradeAvailable: boolean;
  benefitsList: BenefitDetail[];
  ctaText: string;
  lineBgColor?: string[];
  bgColorCodes?: string[];
}

export interface AmenityFacility {
  name: string;
  type: string;
  sequence: number;
  categoryName: string;
  tags: string[];
  attributeName: string;
  highlightedName: string;
}

export interface Amenity {
  name: string;
  facilities: AmenityFacility[];
}

export interface InculsionBenefit {
  benefitText: string;
  iconUrl: string;
  showOnSelectRoom: boolean;
}

export interface InclusionsDetails {
  titleText: string;
  titleTextColor: string;
  benefitList: InculsionBenefit[];
  ctaText: string;
}

export interface InclusionsList {
  code: string;
  text: string;
  subText: string;
  segmentIdentifier: string;
  iconUrl: string;
  category: string;
  onOffer: boolean;
  bookable: boolean;
  packageBenefit: boolean;
  inclusionsDetails: InclusionsDetails;
  showOnSelectRoom: boolean;
  inclusionCode?: string;
  iUrl: string;
}

export interface RoomTariff {
  numberOfAdults: number;
  numberOfChildren: number;
  displayPrice: number;
  roomId: number;
}

export interface PriceBreakup {
  amount: number;
  label: string;
  key: string;
  type: string;
  subTitle?: string;
  breakup?: PriceBreakup[];
}

export interface TopLeftPersuasion {
  iconTag: string;
  text: string;
  imageUrl: string;
  bgColor: string;
  textColor: string;
  borderColor: string;
  template: number;
}

export interface RatePlan {
  rpc: string;
  payMode: string;
  name: string;
  filterCode: any[];
  goTribeInclusion: GoTribeInclusionShape;
  inclusionsList: InclusionsList[];
  cancellationPolicy: CancellationPolicy;
  sellableType: string;
  tariffs: Tariff[];
  supplierCode: string;
  reviewDeeplinkUrl: string;
  staycationDeal: boolean;
  instantConfirmation: string;
  allInclusiveRate: boolean;
  ratePlanPersuasionsMap: Record<string, any>;
  specialFare: boolean;
  segmentId: string;
  packageRateAvailable: boolean;
  linkedRatePlans: LinkedRatePlans[];
  linkedRatePlanAvailable: boolean;
  isLucky: boolean;
  quickBook: {
    roomType: string;
  };
}

export interface LinkedRatePlans {
  ratePlan: RatePlan;
  data: LinkedRatePlanData;
  style: any | null;
}

export interface LinkedRatePlanData {
  ratePlanName: string;
  title: string;
  description: string;
  ctaText: string;
  bottomSheetFooterText: string;
}

export interface Media {
  mediaType: string;
  url: string;
}

export interface PrivateSpace {
  media: Media[];
  id?: string;
  name: string;
  subText: string;
  descriptionText: string;
  openCardText: string;
  sleepingInfoArrangement: SleepingInfoArrangement[];
  spaceId: string;
  spaceType: string;
  isCommonSpace?: boolean;
  areaText?: string;
  spaceInclusions?: string[];
}

export interface SleepingInfoArrangement {
  bedRoom: number;
  bathRoom: number;
  guest: number;
  maxCapacity: number;
  bed: number;
  spaceType: string;
  bedInfos: Record<string, number>;
  subText: string;
  descriptionText: string;
  openCardText: string;
}

export interface SharedInfo {
  iconUrl: string;
  infoText: string;
}

export interface Media {
  mediaType: string;
  url: string;
}

export interface SharedSpace {
  media: Media[];
  name: string;
  descriptionText: string;
  openCardText: string;
  spaceId: string;
  spaceType: string;
  isCommonSpace?: boolean;
  id?: string;
  subText?: string;
  areaText?: string;
  spaceInclusions: string[];
}

export interface SharedSpaces {
  descriptive: string[];
  sharedInfo: SharedInfo;
  spaces: SharedSpace[];
}

export interface TemplateDataSearchRoom {
  SALE_CAMPAIGN: SaleCampaign;
}

export interface SaleCampaign {
  titleText: string;
  titleTextColor: string;
  description: string;
  iconUrl: string;
  backgroundImage: string;
}

export interface RoomBase {
  roomName: string;
  roomCode: string;
  roomViewName: string;
  amenities: Amenity[];
  roomHighlights: RoomHighlight[];
  images: string[];
  ratePlans: RatePlan[];
  clientViewType: ClientViewType;
  maxGuest: number;
  maxAdult: number;
  maxChild: number;
  parentRoomCode: string;
  master: boolean;
  roomSize: string;
  bedCount: number;
  bedroomCount: number;
  bedInfoText: string;
  beds: Bed[];
  maxGuestCount: number;
  maxAdultCount: number;
  maxChildCount: number;
  segments: Segments;
  roomSummary: RoomSummary;
  usp: Record<string, unknown>;
  description: string;
  media: Media[];
  baseGuest: number;
  extraBedCount: number;
  baseRoom: boolean;
  sellableLabel: string;
  filterCode: string[];
  privateSpaces?: {
    descriptive?: string[];
    spaces: PrivateSpace[];
  };
  roomCategoryText?: string;
}
export interface RoomHighlight {
  iconUrl: string;
  text: string;
  description: string;
  identifier: string;
}
export interface Inclusion {
  code: string;
  iconType: string;
  text: string;
  iconUrl: string;
  category: string;
  onOffer: boolean;
  bookable: boolean;
  packageBenefit: boolean;
  inclusionCode?: string;
}
export interface CancellationTimeline {
  checkInDate: string;
  checkInDateTime: string;
  cancellationDate: string;
  cancellationDateTime: string;
  subTitle: string;
  freeCancellationText: string;
  title: string;
  bookingDate: string;
  freeCancellationBenefits: FreeCancellationBenefit[];
}
export interface CancellationPolicyTimeline {
  timeline: Timeline[];
  freeCancellationBenefits: FreeCancellationBenefit[];
  cardChargeTextTitle: string;
  cardChargeTextMsg: string;
  bnplTitleText: string;
  cancellationDate: string;
  cancellationDateTime: string;
  title: string;
}
export interface Timeline {
  startDate: string;
  endDate: string;
  endDateTime: string;
  text: string;
  refundable: boolean;
}

export interface CancellationPolicy {
  iconType: string;
  iconUrl: string;
  text: string;
  subText: string;
  type: string;
  cancelRules: CancelRule[];
}
export interface CancelRule {
  text: string;
  descText?: DescText[];
}
export interface DescText {
  dateText: string;
  feeText: string;
}
export interface Tariff {
  tariffCode: string;
  defaultPriceKey: string;
  occupancydetails: OccupancyDetails;
  roomTariffs: RoomTariff[];
  mtKey: string;
  priceMap: PriceMap;
  availCount: number;
  bnplApplicable: boolean;
}
export interface OccupancyDetails {
  numberOfAdults: number;
  numberOfChildren: number;
  roomCount: number;
  displayPrice: number;
  roomId: number;
}
export interface PriceMap {
  [key: string]: PriceDetailFromSearch;
}
export interface PriceDetailFromSearch {
  details: PriceBreakup[];
  offersAppliedText: string;
  coupons: Coupon[];
  emiBankDetails: EmiBankDetails;
  offersInclusionsList: any[];
  couponSubtext: string;
  pricingKey: string;
  priceDisplayMsg: string;
  couponAmount: number;
  couponDesc: string;
  pinCodeMandatory: boolean;
  currency?: string;
  maxCouponsToShow?: number;
  priceTaxMsg?: string;
}
export interface Coupon {
  code: string;
  description: string;
  subDescription?: string;
  promoIconLink: string;
  couponAmount: number;
  autoApplicable: boolean;
  bnplAllowed: boolean;
  tncUrl: string;
  disabled: boolean;
  bankOffer: boolean;
  ctaBankText: string;
  ctaBankUrl: string;
}
export interface EmiBankDetails {
  type: string;
  tenure: number;
  totalInterest: number;
  bankName: string;
  bankId: string;
  interestRate: number;
  amount: number;
  totalCost: number;
  payOption: string;
  taxIncluded: boolean;
  termType: string;
  interestType: string;
}
export interface TariffPersuasion {
  discountRpc: PersuasionDetail[];
  roomTypeName: PersuasionDetail[];
  cancellationPersuasion: PersuasionDetail[];
  mealPersuasion: PersuasionDetail[];
}
interface PersuasionDetail {
  iconTagName: string;
  persuasionText: string;
  imageUrlList: string[];
  hoverTextData: any;
  colourCodeData: ColourCodeDataFromSearch;
  persuasionFilterId: string;
  persuasionId: string;
  source: string;
  isFilterable: boolean;
  userIdentifier: string;
  imageUrl: string;
  templateType: number;
  overallBgColour: string;
}

export interface ColourCodeDataFromSearch {
  textColour: string;
  bgColour: string;
  isGredient: boolean;
  borderColour: string;
  isBold: boolean;
  gradientStartColour: string;
  gradientEndColour: string;
  sideLineColour: string;
}
export interface ClientViewType {
  totalTariffs: number;
  initialVisible: number;
  baseTariffText: string;
}
export interface Bed {
  type: string;
  count: number;
  bedTypeKey: string | null;
}
export interface Segments {
  segmentList: Record<string, Segment>;
  segmentsCount: number;
}
export interface Segment {
  id: string;
  channelSegment: string;
  userSegment: string;
}
export interface RoomSummary {
  ratingCount: number;
  reviewCount: number;
  topRated: boolean;
  tagData: TagData[];
  disableLowRating: boolean;
}
export interface TagData {
  sentiment: string;
  tagType: string;
  name: string;
  id: string;
}
export interface FreeCancellationBenefit {
  iconType: string;
  text: string;
}
//Combo
export interface Combo {
  comboId: string;
  baseCombo: boolean;
  comboName: string;
  comboTariff: ComboTariff;
  rooms: RoomBase[];
}
export interface ComboTariff {
  defaultPriceKey: string;
  occupancydetails: OccupancyDetails;
  priceMap: {[key: string]: PriceMap};
  availCount: number;
  bnplApplicable: boolean;
}

export interface ExactRoom extends RoomBase {
  clientViewType: {
    totalTariffs: number;
    initialVisible: number;
    baseTariffText: string;
  };
  parentRoomCode: string;
  master: boolean;
  bedInfoText: string;
  usp: Record<string, any>;
  privateSpaces: {
    descriptive: string[];
    spaces: PrivateSpace[];
  };
  baseGuest: number;
  extraBedCount: number;
  baseRoom: boolean;
}

export interface OccupancyRoom extends RoomBase {
  occupancyDetails: OccupancyDetails;
  priceMap: {[key: string]: PriceMap};
}

export interface RecommendedComboRoom extends RoomBase {
  comboId: string;
  baseCombo: boolean;
  comboName: string;
  comboTariff: ComboTariff;
  rooms: RoomBase[];
}

export interface FeatureFlags {
  pahWalletApplicable: boolean;
  realWalletAvailable: boolean;
  payModes: Paymodes;
  freeCancellation: boolean;
  bnpl: boolean;
  pahTariffAvailable: boolean;
  bnplBaseAmount: number;
  bestPriceGuaranteed: boolean;
  firstTimeUser: boolean;
  pahAvailable: boolean;
  requestToBook: boolean;
  rtbPreApproved: boolean;
  rtbAutoCharge: boolean;
  optimisedSelection: boolean;
  skipSelectRoom: boolean;
  groupBookingPrice: boolean;
  maskedPrice: boolean;
  dayUsePersuasion: boolean;
  captureAllPaxDetailsHotel: boolean;
  hotelFareHold: boolean;
  myPartnerMoveToTdsTaxStructure: boolean;
}

export interface GroupFilter {
  text: string;
  image: string;
  ratePlanFilterList: RatePlanFilter[];
  isGroupApplicable: boolean;
}

export interface CardFilter extends GroupFilter {}

export interface RatePlanFilter {
  title: string;
  code: string;
  iconUrl: string;
  selected: boolean;
}

export interface HotelDetailsFromSearch {
  hotelId: string;
  entireProperty: boolean;
  mergedPropType: string;
  supplierId: string;
  voyagerCityId: string;
  locusData: LocusData;
  countryCode: string;
}

export interface LocusData {
  locusId: string;
  locusType: string;
  locusName: string;
  name: string | null;
}
export interface LuckyData {
  luckyProperty: boolean;
}

interface TemplateData {
  templateType: number;
  data: Deal[];
}

interface Deal {
  templateType: number;
  // Add other properties here
}

// interface SearchRoomResponse {
//   exactRooms?: Room[];
//   occupancyRooms?: Room[];

//   hotelPersuasions?: {
//     deals?: Deal[];
//     goTribeBenefits?: Deal[];
//   };
//   previousBookingData?: Room[];
//   hotelPersuasions?: {
//     deals?: TemplateData[];
//     supplyDeals?: TemplateData[];
//     dsdDeals?: TemplateData[];
//   };
// }

export interface RoomAdvisory {
  roomCodeIds: string[];
  bedAdvisoryText: string;
}

export interface RoomInfoFromSearch {
  title: string;
  guestRoomKey: string;
  guestRoomValue: string;
  stayDetail: StayDetail;
  propertyInfoText: string;
}

export interface StayDetail {
  bed: number;
  bedRoom: number;
  maxGuests: number;
  baseGuests: number;
  extraBeds: number;
  sleepInfoText: string;
}

export interface LoginPersuasion {
  loginPersuasionText: string;
  loginPersuasionSubText: string;
}

export interface BestOffer {
  iconTagName: string;
  persuasionText: string;
  imageUrlList: string[];
  hoverTextData: any;
  colourCodeData: ColourCodeDataFromSearch;
  persuasionFilterId: string;
  persuasionId: string;
  source: string;
  isFilterable: boolean;
  userIdentifier: string;
  imageUrl: string;
  templateType: number;
  overallBgColour: string;
}

export interface Card {
  sequence: number;
  cardInfo: SearchCardInfo;
}

export interface SearchCardInfo {
  index: number;
  subType: string;
  id: string;
  titleText: string;
  titleTextColor: string;
  subTextList: string[];
  hasFilter: boolean;
  iconURL: string;
  hasAction: boolean;
  templateId: string;
  hasTooltip: boolean;
  isClaimed: boolean;
  subText: string;
  actionText: string;
  largeIconURL: string;
  cardPayload: CardPayload;
}

export interface TimerCard {
  timerRemaining: number;
  timerRemainingLong: number;
}

export interface CardPayload {
  searchContext?: SearchContext;
  genericCardData?: GenericCardDaum[];
  spokeCityData?: any[];
  title?: string;
  timerCard?: TimerCard;
}

export interface SearchContext {}

export interface GenericCardDaum {
  titleText: string;
  iconUrl: string;
}

export interface Discount {
  iconTagName: string;
  persuasionText: string;
  imageUrlList: string[];
  hoverTextData: any;
  colourCodeData: ColourCodeDataFromSearch;
  persuasionFilterId: string;
  persuasionId: string;
  source: string;
  isFilterable: boolean;
  userIdentifier: string;
  imageUrl: string;
  templateType: number;
  overallBgColour: string;
}

export interface CoupleFriendly {
  iconTagName: string;
  persuasionText: string;
  imageUrlList: string[];
  hoverTextData: any;
  colourCodeData: ColourCodeDataFromSearch;
  persuasionFilterId: string;
  persuasionId: string;
  source: string;
  isFilterable: boolean;
  userIdentifier: string;
  imageUrl: string;
  templateType: number;
  overallBgColour: string;
}

export interface LosCalendarPersuasion {
  iconTagName: string;
  persuasionText: string;
  imageUrlList: string[];
  hoverTextData: string | null;
  colourCodeData: ColourCodeDataFromSearch;
  persuasionFilterId: string;
  persuasionId: string;
  source: string;
  isFilterable: boolean;
  userIdentifier: string;
  imageUrl: string;
  templateType: number;
  overallBgColour: string;
}

export interface HotelPersuasions {
  bestOffersSection: BestOffer[];
  discount: Discount[];
  coupleFriendly: CoupleFriendly[];
  losCalendarPersuasion: LosCalendarPersuasion[];
}

export interface AllInclusiveCard {
  amount: number;
  data: AllInclusiveData[];
  desc: string;
  ratePlanCode: string;
  roomCode: string;
  title: string;
  imageUrl: string;
  persuasionText: string;
}

export interface AllInclusiveData {
  imageUrl: string;
  text: string;
}

export interface AllInclusiveInclusion {
  bulletTexts: string[];
  code: string;
  iconUrl: string;
  imageUrl: string;
}

export interface ContextDetails {
  currency: string;
}

export interface SearchRoom {
  exactRooms?: ExactRoom[];
  occupancyRooms?: OccupancyRoom[];
  recommendedCombos?: RecommendedComboRoom[];
  hotelPersuasions?: HotelPersuasions;
  previousBookingData?: RoomBase[];
  roomAdvisory?: RoomAdvisory;
  roomInfo?: RoomInfoFromSearch;
  loginPersuasion?: LoginPersuasion;
  featureFlags?: FeatureFlags;
  groupFilters?: GroupFilter[];
  hotelDetails?: HotelDetailsFromSearch;
  luckyData?: LuckyData;
  templateData?: TemplateDataSearchRoom;
  allInclusiveCard?: AllInclusiveCard;
  allInclusiveInclusions?: AllInclusiveInclusion[];
  contextDetails?: ContextDetails;
  carryForwardHash: any;
  goTribeInfo: GoTribeInfo;
  cardFilter: {
    cardFilters: CardFilter[];
    isEligibleForCardFilter: boolean;
  };
  spotlightApplicable?: boolean;
}

// Make sure recommendedCombo and occupancyRoom always appear together
export type ValidSearchRoom = SearchRoom &
  (
    | {exactRoom: ExactRoom; recommendedCombo?: never; occupancyRoom?: never}
    | {exactRoom?: never; recommendedCombo: RecommendedComboRoom; occupancyRoom: OccupancyRoom}
  );

export enum DetailsPersuasionKeys {
  IMAGE_TEXT_V = 'IMAGE_TEXT_V',
  IMAGE_TEXT_V_TIMER = 'IMAGE_TEXT_V_TIMER',
  MULTI_PERSUASION_WITH_SHEET = 'MULTI_PERSUASION_WITH_SHEET',
}
